import script from "./ButtonBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonBox.vue?vue&type=script&setup=true&lang=js"

import "./ButtonBox.vue?vue&type=style&index=0&id=1e04cb60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e04cb60"]])

export default __exports__